export const GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_REQUEST = 'GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_REQUEST';
export const GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_SUCCESS = 'GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_SUCCESS';
export const GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_FAILURE = 'GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_FAILURE';

export const CLEAR_KEY_PICKUP_DROP_EVENTS_STATE = 'CLEAR_KEY_PICKUP_DROP_EVENTS_STATE';
